import type { Resource } from "./data/base.ts";

export const entireWorkspace: Readonly<Resource> = {
  id: "(Entire Workspace)",
  locator: "customer",
  service: "(Entire Workspace)",
  type: undefined,
} as const;
